import React from "react";
import "./button.css";

interface SvgRoundIconButtonProps {
  Icon?: React.ReactNode;
  borderRadius?: string;
  background?: string;
  onClick?: () => void;
  className?: string;
  padding?: string;
  style?: React.CSSProperties;
}

const SvgRoundIconButton: React.FC<SvgRoundIconButtonProps> = ({
  Icon,
  onClick,
  borderRadius,
  background,
  padding,
  className = "",
  style = {},
}) => {
  return (
    <button
      type="button"
      className={`btn-round-icon-primary ${className}`}
      onClick={onClick}
      style={{
        background,
        borderRadius,
        padding,
        ...style,
      }}
    >
      {Icon}
    </button>
  );
};

export default SvgRoundIconButton;
